module.exports = __webpack_public_path__ + "adb93f6776a06755d493f525fa40e1c6.MP3";